import type { RecognitionPeak } from '../types';

export type CalibrationStepKind = 'noise' | 'single' | 'chord';

export interface CalibrationStep {
  id: string;
  kind: CalibrationStepKind;
  label: string;
  prepMs?: number;
  expectedMidi?: number[];
  promptMidi?: number[];
  promptVelocity?: number;
  midiRange?: readonly [number, number];
  minDistinctMidis?: number;
  durationMs: number;
}

export interface CalibrationPeakFrame {
  rms: number;
  dominantHz: number | null;
  peaks: RecognitionPeak[];
}

export interface StepCapture {
  rms: number[];
  peakCounts: number[];
  secondRatios: number[];
  dominantHzs: number[];
  allHzs: number[];
  peakFrames: CalibrationPeakFrame[];
}

export interface CalibrationCaptures {
  noise: StepCapture[];
  single: StepCapture[];
  chord: StepCapture[];
}

export const emptyCapture = (): StepCapture => ({
  rms: [],
  peakCounts: [],
  secondRatios: [],
  dominantHzs: [],
  allHzs: [],
  peakFrames: [],
});
